import { useEffect, useState, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import theme from '../../theme';

const TOOLBAR_HEIGHT = 42;
const HEADER_HEIGHT_MOBILE = 56;
const HEADER_HEIGHT_DESKTOP = 60;

const CustomToolbar = ({ toolbarId = 'toolbar', stickyTop }) => {
  const currentTheme = useTheme();
  const isSticky = stickyTop !== undefined;
  const placeholderRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);
  const [toolbarStyle, setToolbarStyle] = useState({});
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const headerHeight = isMobile ? HEADER_HEIGHT_MOBILE : HEADER_HEIGHT_DESKTOP;

  useEffect(() => {
    if (isSticky) return;
    const handleScroll = () => {
      const placeholder = placeholderRef.current;
      if (!placeholder) return;

      const rect = placeholder.getBoundingClientRect();

      if (rect.top <= headerHeight) {
        setIsFixed(true);
        setToolbarStyle({
          position: 'fixed',
          top: headerHeight,
          left: rect.left,
          width: rect.width,
          zIndex: 1200,
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        });
      } else {
        setIsFixed(false);
        setToolbarStyle({});
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [headerHeight, isSticky]);

  return (
    <>
      {!isSticky && <div ref={placeholderRef} style={{ height: isFixed ? TOOLBAR_HEIGHT : 0 }} />}
      <div
        id={toolbarId}
        style={{
          backgroundColor: currentTheme.palette.background.paper,
          ...(isSticky
            ? {
                position: 'sticky',
                top: stickyTop,
                zIndex: 3,
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              }
            : toolbarStyle),
        }}
      >
        {/* 폰트 크기 */}
        <select className="ql-size" defaultValue="14px">
          <option value="9px">9px</option>
          <option value="10px">10px</option>
          <option value="11px">11px</option>
          <option value="12px">12px</option>
          <option value="13px">13px</option>
          <option value="14px">14px</option>
          <option value="15px">15px</option>
          <option value="16px">16px</option>
          <option value="18px">18px</option>
          <option value="20px">20px</option>
          <option value="24px">24px</option>
          <option value="30px">30px</option>
          <option value="40px">40px</option>
          <option value="60px">60px</option>
        </select>

        {/* 텍스트 스타일 */}
        <button className="ql-bold" />
        <button className="ql-italic" />
        <button className="ql-underline" />
        <button className="ql-strike" />

        {/* 색상 */}
        <select className="ql-color" />

        {/* 정렬 */}
        <select className="ql-align" />

        {/* 이미지 업로드 */}
        <button className="ql-link" />
        <button className="ql-image" />
      </div>
    </>
  );
};

export default CustomToolbar;
